import React from 'react';
import {
  FlatList,
  RefreshControl,
  StyleSheet,
  TouchableOpacity,
  View,
} from 'react-native';
import {faChevronRight} from '@fortawesome/free-solid-svg-icons/faChevronRight';
import {FontAwesomeIcon} from '@fortawesome/react-native-fontawesome';

import Text from './Text';

type FlatListMenuItemProps = {
  item: {
    name: string;
    onPress?: () => void;
  };
  onPressItem: (item: any) => void;
};

export function FlatListMenuItem({item, onPressItem}: FlatListMenuItemProps) {
  return (
    <TouchableOpacity
      onPress={() => (item.onPress ? item.onPress() : onPressItem(item))}
      style={styles.item}>
      <View style={styles.itemInside}>
        <Text style={styles.itemText}>{item.name}</Text>
        <FontAwesomeIcon icon={faChevronRight} size={12} style={styles.icon} />
      </View>
    </TouchableOpacity>
  );
}

const FlatListMenuItemSeparator = () => <View style={styles.separator} />;

type FlatListMenuProps = {
  data: any[];
  onRefresh?: () => void;
  onPressItem: (item: any) => void;
  flatlistRef?: any;
};

export default function FlatListMenu({
  data,
  onRefresh,
  onPressItem,
  flatlistRef,
}: FlatListMenuProps) {
  return (
    <FlatList
      refreshControl={
        onRefresh ? (
          <RefreshControl refreshing={false} onRefresh={onRefresh} />
        ) : undefined
      }
      data={data}
      renderItem={({item}) => (
        <FlatListMenuItem item={item} onPressItem={onPressItem} />
      )}
      style={styles.flatList}
      ItemSeparatorComponent={FlatListMenuItemSeparator}
      ref={flatlistRef}
    />
  );
}

const styles = StyleSheet.create({
  item: {
    paddingVertical: 16,
    marginHorizontal: 8,
  },
  itemInside: {
    flexDirection: 'row',
    alignItems: 'center',
    justifyContent: 'space-between',
  },
  itemText: {
    fontSize: 16,
    color: 'black',
  },
  flatList: {},
  icon: {
    color: 'grey',
  },
  separator: {
    borderBottomWidth: 1,
    borderBottomColor: 'lightgrey',
    marginHorizontal: 8,
  },
});
